/**
 * View component for /my-agenda/program/:studySlug
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as resourceLinkActions from '../../resourceLink/resourceLinkActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userModuleActions from '../../userModule/userModuleActions';
import * as userEventActions from '../../userEvent/userEventActions';

// import global components
import { SearchInput } from '../../../global/components/forms';
import Base from '../../../global/components/BaseComponent.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import components 
import AgendaTmListItem from '../components/AgendaTmListItem.js.jsx';
import ProgramAgendaItemsManager from '../components/ProgramAgendaItemsManager.js.jsx';
import ProgramResourceLinkListItem from '../../resourceLink/components/ProgramResourceLinkListItem.js.jsx';
import ProgramResourceLinkTableListItem from '../../resourceLink/components/ProgramResourceLinkTableListItem.js.jsx';

import filterUtils from '../../../global/utils/filterUtils';
// not updating links here because this should no longer be used with london handling agenda

class ProgramResources extends Base {
  constructor(props) {
    super(props);
    this.state = {
      queryText: ''
    }
    this._bind(
      '_handleQuery'
      , '_handleUserEvent'
      , '_handleSort'
    )
  }

  componentDidMount() {
    const { dispatch, loggedInUser, match } = this.props;
    dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id));
    dispatch(userModuleActions.fetchList('_user', loggedInUser._id));
    // dispatch(userNodeActions.fetchListIfNeeded('_user', loggedInUser._id));
    dispatch(studyActions.fetchSingleBySlug(match.params.studySlug)).then(studyRes => {
      if(studyRes.success) {

        // redirect to london
        window.location.replace(`${window.agendaUrl}/${studyRes.item._organization}/${studyRes.item._id}/resources`);
        
        dispatch(resourceLinkActions.fetchListIfNeeded("study", studyRes.item._id));
        dispatch(resourceLinkActions.setFilter({query: '', sortBy: 'name'}, 'study', studyRes.item._id));
        dispatch(sponsorActions.fetchSingleIfNeeded(studyRes.item._organization));
        dispatch(studyUserActions.fetchListIfNeeded("_group", studyRes.item._id, "_user", loggedInUser._id));
      } else {
        alert('something wrong')
        // TODO: proper alert 
      }
    })

  }

  _handleQuery(e) {
    this.setState({
      [e.target.name]: e.target.value.toLowerCase()
    });
  }

  _handleUserEvent(resourceLink, studyId) {
    const { dispatch, loggedInUser } = this.props;
    dispatch(userEventActions.sendCreateUserEvent({
      eventType: "link"
      , eventAction: "outbound"
      , _user: loggedInUser._id
      , _resourceLink: resourceLink._id 
      , _group: studyId
      , description: resourceLink.url 
    }));
  }

  _handleSort(sortBy) {
    const { dispatch, resourceLinkList } = this.props;
    let newFilter = resourceLinkList.filter;
    if(resourceLinkList.filter.sortBy && resourceLinkList.filter.sortBy.indexOf("-") < 0) {
      sortBy = "-" + sortBy;
    } else {
      sortBy = sortBy.substring(0)
    }
    newFilter.sortBy = sortBy;
    dispatch(resourceLinkActions.setFilter(newFilter));
  }

  render() {
    const {
      sponsorStore 
      , studyStore 
      , studyUserStore 
      , sortedResourceLinkList
      , loggedInUser
      , resourceLinkList
    } = this.props;

    const { 
      queryText
    } = this.state;

    const selectedStudy = studyStore.selected.getItem();
    const selectedSponsor = sponsorStore.selected.getItem();
    const studyUserList = selectedStudy ? studyUserStore.util.getList("_group", selectedStudy._id, "_user", currentUser._id) : [];
    const isEmpty = (
      !selectedStudy
      || !selectedStudy._id
      || !selectedSponsor
      || !selectedSponsor._id
      || !sortedResourceLinkList
    );

    const isFetching = (
      sponsorStore.selected.isFetching
      || studyStore.selected.isFetching 
    )

    const studyUserText = (
      studyUserList
      && studyUserList[0]
    ) ?
        studyUserList[0].role == "unknown" ?
          `` // not much else to put here, but looks bad if site null and role == unknown
        :
          `You are currently viewing these program resources as ${studyUserList[0].role} (Site/Team Number: ${studyUserList[0].siteNumber}) `
      : loggedInUser && loggedInUser.admin ?
        `You are viewing these program resources as an ADMIN`
      :
        `You do not have access to this Program - Please contact an administrator`;

    return(
      <StudyLayout>
        <Helmet
          title={"Program Resources | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section my-agenda -program">
            {/* <div className="-content-wrapper"> */}
            <div className="yt-container">
              { isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="u-centerText">
                    <h2>No programs were found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate to your <Link to="/my-agenda">Agenda</Link> to try another program!</p>
                  </div>
                )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                  <div className="agenda-header">
                    <img className="-logo" src={selectedSponsor.logo}/>
                    <div className="-sponsor-top">
                      <strong>Program Resources</strong>
                      <h2 className="-study-name">{selectedStudy.name}</h2>
                      <p><em>{studyUserText}</em></p>
                    </div>
                  </div>
                  <div className="yt-tools ">
                    <div className="search">
                      <SearchInput
                        change={this._handleQuery}
                        name="queryText"
                        placeholder="Find..."
                        required={false}
                        value={queryText}
                        />
                    </div>
                  </div>
                  <div className="table-wrapper">
                    <table className="yt-table striped">
                      <thead>
                        <tr>
                          <th className="-resource-icon-col">
                            
                          </th>
                          <th className="_40 sortable" onClick={()=> this._handleSort('name')}>
                            Resource
                            {resourceLinkList.filter.sortBy === '-name' ?
                              <i className="ion ion-ios-arrow-up" />
                              : resourceLinkList.filter.sortBy === 'name' ?
                              <i className="ion ion-ios-arrow-down" />
                              : null
                            }
                          </th>
                          <th className="_40 sortable" onClick={()=> this._handleSort('created')}>
                            Created
                            {resourceLinkList.filter.sortBy === '-created' ?
                              <i className="ion ion-ios-arrow-down" />
                              : resourceLinkList.filter.sortBy === 'created' ?
                              <i className="ion ion-ios-arrow-up" />
                              : null
                            }
                          </th>
                          <th className="_40 sortable" onClick={()=> this._handleSort('updated')}>
                            Modified
                            {resourceLinkList.filter.sortBy === '-updated' ?
                              <i className="ion ion-ios-arrow-down" />
                              : resourceLinkList.filter.sortBy === 'updated' ?
                              <i className="ion ion-ios-arrow-up" />
                              : null
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody className="aut-metrics-table-body">
                        { sortedResourceLinkList.length > 0 ?
                          sortedResourceLinkList.filter(item => filterUtils.filterResourceLink(queryText, item)).map((resourceLink, i) =>
                            <ProgramResourceLinkTableListItem
                              key={resourceLink + '_' + i}
                              handleUserEvent={() => this._handleUserEvent(resourceLink, selectedStudy._id)}
                              resourceLink={resourceLink}
                            /> 
                          )
                          :
                          <tr>
                            <td colSpan="3">
                              <em>No resources for this program</em>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


ProgramResources.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store, ownProps) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  const selectedStudy = store.study.selected.getItem();
  const resourceLinkStore = store.resourceLink
  const resourceLinkList = resourceLinkStore.lists && resourceLinkStore.lists.study ? resourceLinkStore.lists.study[selectedStudy._id] : null;
  let sortedList = [];
  if (resourceLinkList) {
    const filter = resourceLinkList.filter;
    const sortBy = filter ? filter.sortBy : 'name';

    // SORT THE LIST
    sortedList = resourceLinkList.items.map((item) => {
      let newItem = resourceLinkStore.byId[item];
      return newItem; 
    });
    switch(sortBy) {
      case 'name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
        break;
      case '-name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['desc']);
        break;
        case 'updated':
          sortedList = _.orderBy(sortedList, [item => item.updated], ['asc']);
          break;
        case '-updated':
          sortedList = _.orderBy(sortedList, [item => item.updated], ['desc']);
          break;
      case 'created':
        sortedList = _.orderBy(sortedList, [item => item.created], ['asc']);
        break;
      case '-created':
        sortedList = _.orderBy(sortedList, [item => item.created], ['desc']);
        break;
      default:
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
    }
  }
  return {
    loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , resourceLinkStore: resourceLinkStore
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , studyUserStore: store.studyUser 
    , contentModuleStore: store.contentModule
    , userModuleStore: store.userModule 
    , resourceLinkList: resourceLinkList
    , sortedResourceLinkList: sortedList
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ProgramResources)
);



// WEBPACK FOOTER //
// modules/agenda/views/ProgramResources.js.jsx